/*
    Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
    They are written in English to avoid character encoding issues
*/
export const LANGUAGES: string[] = [
  'it',
  'en',
  'es'
];

/**
 * ISO2 codes https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
 */
export const TELEPHONE_CODES_LANGUAGES: string [] = [
  'it',
  'gb',
  'es'
]

